// How long note information should be considered relevant. Realistically the note and user will change extremely rarely
// so this time can be fairly long.
export const STALE_MILLISECONDS = 60000;
